<template>
    <v-layout row justify-space-around mx-5 mb-10 :class="{'column':$vuetify.breakpoint.mdAndDown}">
        <v-flex xs4 :class="{'mb-5':$vuetify.breakpoint.mdAndDown}" v-for="(item,i) in dataCardStats" :key="i">

            <v-card class="cardStats py-5 px-7 mx-3 mb-4" :style="[$vuetify.breakpoint.mdAndUp ? {'height':'175px'}:{}]">
                <v-layout style="width: 100%;height: 100%" :class="{ 'column':$vuetify.breakpoint.smAndDown }">
                    <v-flex class="align-center" :class="{ 'mr-12':$vuetify.breakpoint.mdAndUp,'align-self-center':$vuetify.breakpoint.smAndDown }" style="display: flex">
                        <img style="width: 79px" :src="require('../../assets/icon/'+item.img_file)">
                    </v-flex>
                    <v-flex>
                        <v-layout column>
                            <v-flex mb-2 style="font-size: 15px;color: #FF5100">
                                <!-- TODO: Waiting for Integrate API -->
                                {{ (sum(item.qty) === undefined || sum(item.qty) === null) ? '826,027':sum(item.qty) }}
                            </v-flex>
                            <v-flex class="text-left" style="font-size: 13px">
                                {{ item.text + (year === undefined ? '':' ปี '+year) }}
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <div class="text-left">
                <v-btn small depressed fab class="mx-2" color="#FF5100">
                    <v-icon class="white--text">add</v-icon>
                </v-btn>
                <span style="user-select: none;cursor: pointer">
                    ดูเพิ่มเติม
                </span>
            </div>

        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        name: "StatCards",
        props: ['year','labor'],
        components: {

        },
        data: () => ({
            dataCardStats: [
                { img_file: 'card1.png', qty: '9,352,595', text: 'มูลค่าการส่งออกของกลุ่ม เศรษฐกิจสร้างสรรค์ (ล้านบาท)', link: '/' },
                { img_file: 'card2.png', qty: '104,367,846', text: 'มูลค่าของอุตสาหกรรม สร้างสรรค์ของประเทศไทย (ล้านบาท)', link: '/' },
                { img_file: 'card3.png', qty: null, text: 'จำนวนแรงงานสร้างสรรค์ ของไทย (คน)', link: '/' }
            ]
        }),
        watch: {
          labor: function(a, b) {
              this.dataCardStats[2].qty = this.labor;
          }
        },
        methods: {
            sum(arrayOfNum) {
                if (Array.isArray(arrayOfNum)) {
                    let total = 0;
                    arrayOfNum.forEach((item)=> {
                        total += parseInt(item);
                    });
                    return this.formatNumber(total);
                } else {
                    return arrayOfNum;
                }
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            }

        }
    }
</script>

<style scoped>

    * {
        font-size: 12px;
    }

    .cardStats {
        border: 1px solid #FF5100 !important;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
        border-radius: 0;
    }

</style>
